// Third-party
import React from 'react';
import { connect } from 'react-redux';

// Redux
import { ReduxState } from '../../../redux/modules/types';

// Utils
import BeamerUtils from '../../../utils/3rd-party/beamer';
import User from '@/types/user';
import Locale from '@/types/locale';

type StateProps = {
  user?: User | null;
  locale: Locale;
};

type Props = StateProps & {
  children: React.ReactNode;
};

class ExternalNotificationCenterProvider extends React.Component<Props> {
  getFilters(user?: User): string {
    return user ? user.notificationFilters.join(';') : '';
  }

  componentDidMount() {
    const { locale, user } = this.props;

    if (user) {
      BeamerUtils.init({
        filter: this.getFilters(user),
        language: locale.substring(0, 2).toUpperCase(),
        user_email: user.email,
        user_id: user.id,
      });
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { user: prevUser } = prevProps;
    const { locale, user } = this.props;
    const language = locale.substring(0, 2).toUpperCase();

    if (prevUser !== user && !user) {
      BeamerUtils.destroy();
      return;
    }

    if (prevUser === null && user) {
      BeamerUtils.init({
        filter: this.getFilters(user),
        language,
        user_email: user.email,
        user_id: user.id,
      });
      return;
    }

    if (prevUser !== null && user !== null && prevUser !== user) {
      BeamerUtils.update({
        filter: this.getFilters(user),
        language,
        user_email: user?.email,
        user_id: user?.id,
      });
    }
  }

  render() {
    return this.props.children;
  }
}

const mapStateToProps = (state: ReduxState): StateProps => ({
  user: state.auth.user,
  locale: state.intl.locale,
});

export default connect(mapStateToProps)(ExternalNotificationCenterProvider);
